import script from "./ValidationHistoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationHistoryList.vue?vue&type=script&setup=true&lang=js"

import "./ValidationHistoryList.vue?vue&type=style&index=0&id=38ba82c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ba82c8"]])

export default __exports__